export const ROLES = Object.freeze({
  TECHNICAL: 'Technical',
  USER: 'User',
  ADMIN: 'Admin',
  SUPER_ADMIN: 'SuperAdmin',
  GENERAL: 'General'
});
